module.exports = __webpack_public_path__ + "media/honey-icons/icon-incorrect-sound-22e59a3a.svg";